type City = {
  name: string;
};

type CityNamesSource = {
  cities?: City[] | null;
  city?: City | null;
  region?: City | null;
};

export const getCityNames = ({
  cities,
  city,
  region,
}: CityNamesSource): string => {
  if (cities?.length) {
    return cities.map(item => item.name).join(', ');
  }

  return city?.name ?? region?.name ?? '';
};
